/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.3.0 (NJsonSchema v10.4.4.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
import axios from 'axios';
export class AccountClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    signUp(body, cancelToken) {
        let url_ = this.baseUrl + "/api/Account/SignUp";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSignUp(_response);
        });
    }
    processSignUp(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = BearerTokenOutputModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    logIn(body, cancelToken) {
        let url_ = this.baseUrl + "/api/Account/LogIn";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processLogIn(_response);
        });
    }
    processLogIn(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = BearerTokenOutputModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    signUpAnonymous(cancelToken) {
        let url_ = this.baseUrl + "/api/Account/SignUpAnonymous";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSignUpAnonymous(_response);
        });
    }
    processSignUpAnonymous(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = BearerTokenOutputModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    changePassword(body, cancelToken) {
        let url_ = this.baseUrl + "/api/Account/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processChangePassword(_response);
        });
    }
    processChangePassword(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param email (optional)
     * @param language (optional)
     * @return Success
     */
    forgotPassword(email, language, cancelToken) {
        let url_ = this.baseUrl + "/api/Account/ForgotPassword?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processForgotPassword(_response);
        });
    }
    processForgotPassword(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateCustomerInfo(body, cancelToken) {
        let url_ = this.baseUrl + "/api/Account/UpdateCustomerInfo";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateCustomerInfo(_response);
        });
    }
    processUpdateCustomerInfo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    customerInfo(cancelToken) {
        let url_ = this.baseUrl + "/api/Account/CustomerInfo";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCustomerInfo(_response);
        });
    }
    processCustomerInfo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = FECustomerOutputModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    confirmReset(body, cancelToken) {
        let url_ = this.baseUrl + "/api/Account/ConfirmReset";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processConfirmReset(_response);
        });
    }
    processConfirmReset(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class CartClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    cart(cancelToken) {
        let url_ = this.baseUrl + "/api/Cart/Cart";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCart(_response);
        });
    }
    processCart(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = FECartOutputModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    addItem(body, cancelToken) {
        let url_ = this.baseUrl + "/api/Cart/AddItem";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAddItem(_response);
        });
    }
    processAddItem(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    removeItem(body, cancelToken) {
        let url_ = this.baseUrl + "/api/Cart/RemoveItem";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRemoveItem(_response);
        });
    }
    processRemoveItem(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateQuantity(body, cancelToken) {
        let url_ = this.baseUrl + "/api/Cart/UpdateQuantity";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateQuantity(_response);
        });
    }
    processUpdateQuantity(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class CatalogClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    categories(cancelToken) {
        let url_ = this.baseUrl + "/api/Catalog/Categories";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCategories(_response);
        });
    }
    processCategories(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(FECategoryOutputModel.fromJS(item));
            }
            else {
                result200 = null;
            }
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    allCategories(cancelToken) {
        let url_ = this.baseUrl + "/api/Catalog/AllCategories";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAllCategories(_response);
        });
    }
    processAllCategories(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = FEAllCategoriesOutputModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    pagedItems(body, cancelToken) {
        let url_ = this.baseUrl + "/api/Catalog/PagedItems";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPagedItems(_response);
        });
    }
    processPagedItems(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = FEPagedItemsOutputModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param outlineId (optional)
     * @return Success
     */
    getItemByOutlineId(outlineId, cancelToken) {
        let url_ = this.baseUrl + "/api/Catalog/GetItemByOutlineId?";
        if (outlineId !== undefined && outlineId !== null)
            url_ += "outlineId=" + encodeURIComponent("" + outlineId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetItemByOutlineId(_response);
        });
    }
    processGetItemByOutlineId(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = FEItemOutputModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param itemId (optional)
     * @return Success
     */
    getItem(itemId, cancelToken) {
        let url_ = this.baseUrl + "/api/Catalog/GetItem?";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetItem(_response);
        });
    }
    processGetItem(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = FEItemOutputModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    search(body, cancelToken) {
        let url_ = this.baseUrl + "/api/Catalog/Search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = FEPagedItemsOutputModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    homeBanner(cancelToken) {
        let url_ = this.baseUrl + "/api/Catalog/HomeBanner";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processHomeBanner(_response);
        });
    }
    processHomeBanner(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = FEBannerOutputModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    homePageItems(cancelToken) {
        let url_ = this.baseUrl + "/api/Catalog/HomePageItems";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processHomePageItems(_response);
        });
    }
    processHomePageItems(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(FEItemOutputModel.fromJS(item));
            }
            else {
                result200 = null;
            }
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    helpRequestForms(cancelToken) {
        let url_ = this.baseUrl + "/api/Catalog/HelpRequestForms";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processHelpRequestForms(_response);
        });
    }
    processHelpRequestForms(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(FEHelpRequestFormOutputModel.fromJS(item));
            }
            else {
                result200 = null;
            }
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param id (optional)
     * @return Success
     */
    helpRequestFormById(id, cancelToken) {
        let url_ = this.baseUrl + "/api/Catalog/HelpRequestFormById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processHelpRequestFormById(_response);
        });
    }
    processHelpRequestFormById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = FEHelpRequestFormOutputModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param id (optional)
     * @param key (optional)
     * @return Success
     */
    privateHelpRequestFormById(id, key, cancelToken) {
        let url_ = this.baseUrl + "/api/Catalog/PrivateHelpRequestFormById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPrivateHelpRequestFormById(_response);
        });
    }
    processPrivateHelpRequestFormById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = FEHelpRequestFormOutputModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    dedicationDesigns(cancelToken) {
        let url_ = this.baseUrl + "/api/Catalog/DedicationDesigns";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDedicationDesigns(_response);
        });
    }
    processDedicationDesigns(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DedicationDesignOutputModel.fromJS(item));
            }
            else {
                result200 = null;
            }
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class HelpClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createHelpRequest(body, cancelToken) {
        let url_ = this.baseUrl + "/api/Help/CreateHelpRequest";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateHelpRequest(_response);
        });
    }
    processCreateHelpRequest(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param contentType (optional)
     * @param contentDisposition (optional)
     * @param headers (optional)
     * @param length (optional)
     * @param name (optional)
     * @param fileName (optional)
     * @return Success
     */
    upload(contentType, contentDisposition, headers, length, name, fileName, cancelToken) {
        let url_ = this.baseUrl + "/api/Help/upload";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            content_.append("Headers", JSON.stringify(headers));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpload(_response);
        });
    }
    processUpload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = UploadedImageFileOutputModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class OrderClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param trandata (optional)
     * @param errorText (optional)
     * @return Success
     */
    knetexternalpaymentcallback(trandata, errorText, cancelToken) {
        let url_ = this.baseUrl + "/api/Order/knetexternalpaymentcallback";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (trandata !== null && trandata !== undefined)
            content_.append("trandata", trandata.toString());
        if (errorText !== null && errorText !== undefined)
            content_.append("ErrorText", errorText.toString());
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processKnetexternalpaymentcallback(_response);
        });
    }
    processKnetexternalpaymentcallback(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param number (optional)
     * @return Success
     */
    orderSummaryByNumber(number, cancelToken) {
        let url_ = this.baseUrl + "/api/Order/OrderSummaryByNumber?";
        if (number !== undefined && number !== null)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processOrderSummaryByNumber(_response);
        });
    }
    processOrderSummaryByNumber(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = FEOrderSummaryOutputModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param number (optional)
     * @param paymentId (optional)
     * @param transactionId (optional)
     * @return Success
     */
    orderSummaryByPaymentInfo(number, paymentId, transactionId, cancelToken) {
        let url_ = this.baseUrl + "/api/Order/OrderSummaryByPaymentInfo?";
        if (number !== undefined && number !== null)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        if (paymentId !== undefined && paymentId !== null)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        if (transactionId !== undefined && transactionId !== null)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processOrderSummaryByPaymentInfo(_response);
        });
    }
    processOrderSummaryByPaymentInfo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = FEOrderSummaryOutputModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    createOrder(cancelToken) {
        let url_ = this.baseUrl + "/api/Order/CreateOrder";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateOrder(_response);
        });
    }
    processCreateOrder(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = ExternnalPaymentUrlOutputModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createOrderWithDedication(body, cancelToken) {
        let url_ = this.baseUrl + "/api/Order/CreateOrderWithDedication";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateOrderWithDedication(_response);
        });
    }
    processCreateOrderWithDedication(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = ExternnalPaymentUrlOutputModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    customerOrders(cancelToken) {
        let url_ = this.baseUrl + "/api/Order/CustomerOrders";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCustomerOrders(_response);
        });
    }
    processCustomerOrders(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(FEOrderOutputModel.fromJS(item));
            }
            else {
                result200 = null;
            }
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param orderId (optional)
     * @return Success
     */
    orderDetailById(orderId, cancelToken) {
        let url_ = this.baseUrl + "/api/Order/OrderDetailById?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processOrderDetailById(_response);
        });
    }
    processOrderDetailById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = FEOrderOutputModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param number (optional)
     * @param paymentId (optional)
     * @param transactionId (optional)
     * @return Success
     */
    orderDetailByPaymentInfo(number, paymentId, transactionId, cancelToken) {
        let url_ = this.baseUrl + "/api/Order/OrderDetailByPaymentInfo?";
        if (number !== undefined && number !== null)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        if (paymentId !== undefined && paymentId !== null)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        if (transactionId !== undefined && transactionId !== null)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processOrderDetailByPaymentInfo(_response);
        });
    }
    processOrderDetailByPaymentInfo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = FEOrderOutputModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class SignUpInputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.countryCode = _data["countryCode"];
            this.password = _data["password"];
            this.language = _data["language"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpInputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["countryCode"] = this.countryCode;
        data["password"] = this.password;
        data["language"] = this.language;
        return data;
    }
}
export class BearerTokenOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.isRegistered = _data["isRegistered"];
            this.token = _data["token"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BearerTokenOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isRegistered"] = this.isRegistered;
        data["token"] = this.token;
        return data;
    }
}
export class ProblemDetails {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {};
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        this.extensions[key] = _data["extensions"][key];
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    data["extensions"][key] = this.extensions[key];
            }
        }
        return data;
    }
}
export class LogInInputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.language = _data["language"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LogInInputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["language"] = this.language;
        return data;
    }
}
export class ChangePasswordInputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
            this.language = _data["language"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        data["language"] = this.language;
        return data;
    }
}
export class UpdateCustomerInfoInputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.language = _data["language"];
            this.phone = _data["phone"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerInfoInputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["language"] = this.language;
        data["phone"] = this.phone;
        return data;
    }
}
export class FECustomerOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.userId = _data["userId"];
            this.isRegistered = _data["isRegistered"];
            this.language = _data["language"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FECustomerOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["userId"] = this.userId;
        data["isRegistered"] = this.isRegistered;
        data["language"] = this.language;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    }
}
export class ResetPasswordInputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userId = _data["userId"];
            this.token = _data["token"];
            this.password = _data["password"];
            this.language = _data["language"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["token"] = this.token;
        data["password"] = this.password;
        data["language"] = this.language;
        return data;
    }
}
export class LocalizedStringOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.english = _data["english"];
            this.arabic = _data["arabic"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedStringOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["english"] = this.english;
        data["arabic"] = this.arabic;
        return data;
    }
}
export var ItemType;
(function (ItemType) {
    ItemType["OpenDonation"] = "OpenDonation";
    ItemType["TargetCostDonation"] = "TargetCostDonation";
})(ItemType || (ItemType = {}));
export var ItemPaymentType;
(function (ItemPaymentType) {
    ItemPaymentType["UserInputAmount"] = "UserInputAmount";
    ItemPaymentType["FixedAmount"] = "FixedAmount";
})(ItemPaymentType || (ItemPaymentType = {}));
export class FECartLineItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.originalItemId = _data["originalItemId"];
            this.name = _data["name"] ? LocalizedStringOutputModel.fromJS(_data["name"]) : undefined;
            this.variationOptionDispalyText = _data["variationOptionDispalyText"] ? LocalizedStringOutputModel.fromJS(_data["variationOptionDispalyText"]) : undefined;
            this.barcode = _data["barcode"];
            this.type = _data["type"];
            this.paymentType = _data["paymentType"];
            this.fixedDonationAmount = _data["fixedDonationAmount"];
            this.quantity = _data["quantity"];
            this.paidAmount = _data["paidAmount"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FECartLineItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["originalItemId"] = this.originalItemId;
        data["name"] = this.name ? this.name.toJSON() : undefined;
        data["variationOptionDispalyText"] = this.variationOptionDispalyText ? this.variationOptionDispalyText.toJSON() : undefined;
        data["barcode"] = this.barcode;
        data["type"] = this.type;
        data["paymentType"] = this.paymentType;
        data["fixedDonationAmount"] = this.fixedDonationAmount;
        data["quantity"] = this.quantity;
        data["paidAmount"] = this.paidAmount;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    }
}
export class FECartOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [];
                for (let item of _data["lineItems"])
                    this.lineItems.push(FECartLineItem.fromJS(item));
            }
            this.total = _data["total"];
            this.lastSync = _data["lastSync"] ? new Date(_data["lastSync"].toString()) : undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FECartOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["lastSync"] = this.lastSync ? this.lastSync.toISOString() : undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    }
}
export class AddCartItemInputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.cartId = _data["cartId"];
            this.quantity = _data["quantity"];
            this.itemId = _data["itemId"];
            this.amount = _data["amount"];
            this.language = _data["language"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddCartItemInputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["cartId"] = this.cartId;
        data["quantity"] = this.quantity;
        data["itemId"] = this.itemId;
        data["amount"] = this.amount;
        data["language"] = this.language;
        return data;
    }
}
export class RemoveCartItemInputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.cartId = _data["cartId"];
            this.lineItemId = _data["lineItemId"];
            this.language = _data["language"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveCartItemInputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["cartId"] = this.cartId;
        data["lineItemId"] = this.lineItemId;
        data["language"] = this.language;
        return data;
    }
}
export class UpdateCartItemQuantityInputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.cartId = _data["cartId"];
            this.lineItemId = _data["lineItemId"];
            this.language = _data["language"];
            this.quantity = _data["quantity"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCartItemQuantityInputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["cartId"] = this.cartId;
        data["lineItemId"] = this.lineItemId;
        data["language"] = this.language;
        data["quantity"] = this.quantity;
        return data;
    }
}
export class FECategoryOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"] ? LocalizedStringOutputModel.fromJS(_data["name"]) : undefined;
            this.description = _data["description"] ? LocalizedStringOutputModel.fromJS(_data["description"]) : undefined;
            this.outlineId = _data["outlineId"];
            this.outline = _data["outline"];
            this.path = _data["path"];
            this.childrenCategoriesOutline = _data["childrenCategoriesOutline"];
            this.parentCategoryId = _data["parentCategoryId"];
            this.imageUrl = _data["imageUrl"] ? LocalizedStringOutputModel.fromJS(_data["imageUrl"]) : undefined;
            this.sortOrder = _data["sortOrder"];
            this.isVisible = _data["isVisible"];
            if (Array.isArray(_data["subCategories"])) {
                this.subCategories = [];
                for (let item of _data["subCategories"])
                    this.subCategories.push(FECategoryOutputModel.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FECategoryOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name ? this.name.toJSON() : undefined;
        data["description"] = this.description ? this.description.toJSON() : undefined;
        data["outlineId"] = this.outlineId;
        data["outline"] = this.outline;
        data["path"] = this.path;
        data["childrenCategoriesOutline"] = this.childrenCategoriesOutline;
        data["parentCategoryId"] = this.parentCategoryId;
        data["imageUrl"] = this.imageUrl ? this.imageUrl.toJSON() : undefined;
        data["sortOrder"] = this.sortOrder;
        data["isVisible"] = this.isVisible;
        if (Array.isArray(this.subCategories)) {
            data["subCategories"] = [];
            for (let item of this.subCategories)
                data["subCategories"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    }
}
export class FEAllCategoriesOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["flatCategories"])) {
                this.flatCategories = [];
                for (let item of _data["flatCategories"])
                    this.flatCategories.push(FECategoryOutputModel.fromJS(item));
            }
            if (Array.isArray(_data["categoryTree"])) {
                this.categoryTree = [];
                for (let item of _data["categoryTree"])
                    this.categoryTree.push(FECategoryOutputModel.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FEAllCategoriesOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.flatCategories)) {
            data["flatCategories"] = [];
            for (let item of this.flatCategories)
                data["flatCategories"].push(item.toJSON());
        }
        if (Array.isArray(this.categoryTree)) {
            data["categoryTree"] = [];
            for (let item of this.categoryTree)
                data["categoryTree"].push(item.toJSON());
        }
        return data;
    }
}
export var SortBy;
(function (SortBy) {
    SortBy["SortOrderAscending"] = "SortOrderAscending";
    SortBy["SortOrderDescending"] = "SortOrderDescending";
    SortBy["CostAscending"] = "CostAscending";
    SortBy["CostDescending"] = "CostDescending";
    SortBy["CreatedAtAscending"] = "CreatedAtAscending";
    SortBy["CreatedAtDescending"] = "CreatedAtDescending";
    SortBy["UncompletedFirst"] = "UncompletedFirst";
})(SortBy || (SortBy = {}));
export class PagedItemFilterInputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.categoryOutlineId = _data["categoryOutlineId"];
            this.sortBy = _data["sortBy"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.searchText = _data["searchText"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedItemFilterInputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["categoryOutlineId"] = this.categoryOutlineId;
        data["sortBy"] = this.sortBy;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["searchText"] = this.searchText;
        return data;
    }
}
export var ItemStatus;
(function (ItemStatus) {
    ItemStatus["None"] = "None";
    ItemStatus["NotCompleted"] = "NotCompleted";
    ItemStatus["Completed"] = "Completed";
})(ItemStatus || (ItemStatus = {}));
export var VariationOption;
(function (VariationOption) {
    VariationOption["None"] = "None";
    VariationOption["Dropdown"] = "Dropdown";
    VariationOption["Radio"] = "Radio";
})(VariationOption || (VariationOption = {}));
export class FESuggestedAmountOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.amount = _data["amount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FESuggestedAmountOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        return data;
    }
}
export class FEItemImageOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.url = _data["url"];
            this.sortOrder = _data["sortOrder"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FEItemImageOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["sortOrder"] = this.sortOrder;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    }
}
export class FEItemOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.status = _data["status"];
            this.name = _data["name"] ? LocalizedStringOutputModel.fromJS(_data["name"]) : undefined;
            this.itemOption = _data["itemOption"];
            this.variationOptionDisplayText = _data["variationOptionDisplayText"] ? LocalizedStringOutputModel.fromJS(_data["variationOptionDisplayText"]) : undefined;
            this.variationOptionLabelText = _data["variationOptionLabelText"] ? LocalizedStringOutputModel.fromJS(_data["variationOptionLabelText"]) : undefined;
            this.variationOptionHintText = _data["variationOptionHintText"] ? LocalizedStringOutputModel.fromJS(_data["variationOptionHintText"]) : undefined;
            this.description = _data["description"] ? LocalizedStringOutputModel.fromJS(_data["description"]) : undefined;
            this.shortDescription = _data["shortDescription"] ? LocalizedStringOutputModel.fromJS(_data["shortDescription"]) : undefined;
            this.cost = _data["cost"];
            this.paidAmount = _data["paidAmount"];
            this.fixedDonationAmount = _data["fixedDonationAmount"];
            this.defaultUserInputAmount = _data["defaultUserInputAmount"];
            this.type = _data["type"];
            this.paymentType = _data["paymentType"];
            this.isVariant = _data["isVariant"];
            this.hasVariations = _data["hasVariations"];
            if (Array.isArray(_data["variations"])) {
                this.variations = [];
                for (let item of _data["variations"])
                    this.variations.push(FEItemOutputModel.fromJS(item));
            }
            this.displaySuggestedAmounts = _data["displaySuggestedAmounts"];
            if (Array.isArray(_data["suggestedAmounts"])) {
                this.suggestedAmounts = [];
                for (let item of _data["suggestedAmounts"])
                    this.suggestedAmounts.push(FESuggestedAmountOutputModel.fromJS(item));
            }
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["images"])) {
                this.images = [];
                for (let item of _data["images"])
                    this.images.push(FEItemImageOutputModel.fromJS(item));
            }
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.barcode = _data["barcode"];
            this.outlineId = _data["outlineId"];
            this.outline = _data["outline"];
            this.mainThumbnailUrl = _data["mainThumbnailUrl"];
            this.paymentProgress = _data["paymentProgress"];
            this.isCommingSoon = _data["isCommingSoon"];
            this.commingSoonText = _data["commingSoonText"] ? LocalizedStringOutputModel.fromJS(_data["commingSoonText"]) : undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FEItemOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["name"] = this.name ? this.name.toJSON() : undefined;
        data["itemOption"] = this.itemOption;
        data["variationOptionDisplayText"] = this.variationOptionDisplayText ? this.variationOptionDisplayText.toJSON() : undefined;
        data["variationOptionLabelText"] = this.variationOptionLabelText ? this.variationOptionLabelText.toJSON() : undefined;
        data["variationOptionHintText"] = this.variationOptionHintText ? this.variationOptionHintText.toJSON() : undefined;
        data["description"] = this.description ? this.description.toJSON() : undefined;
        data["shortDescription"] = this.shortDescription ? this.shortDescription.toJSON() : undefined;
        data["cost"] = this.cost;
        data["paidAmount"] = this.paidAmount;
        data["fixedDonationAmount"] = this.fixedDonationAmount;
        data["defaultUserInputAmount"] = this.defaultUserInputAmount;
        data["type"] = this.type;
        data["paymentType"] = this.paymentType;
        data["isVariant"] = this.isVariant;
        data["hasVariations"] = this.hasVariations;
        if (Array.isArray(this.variations)) {
            data["variations"] = [];
            for (let item of this.variations)
                data["variations"].push(item.toJSON());
        }
        data["displaySuggestedAmounts"] = this.displaySuggestedAmounts;
        if (Array.isArray(this.suggestedAmounts)) {
            data["suggestedAmounts"] = [];
            for (let item of this.suggestedAmounts)
                data["suggestedAmounts"].push(item.toJSON());
        }
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["barcode"] = this.barcode;
        data["outlineId"] = this.outlineId;
        data["outline"] = this.outline;
        data["mainThumbnailUrl"] = this.mainThumbnailUrl;
        data["paymentProgress"] = this.paymentProgress;
        data["isCommingSoon"] = this.isCommingSoon;
        data["commingSoonText"] = this.commingSoonText ? this.commingSoonText.toJSON() : undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    }
}
export class PagedMetadata {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.totalItemCount = _data["totalItemCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.numberOfPages = _data["numberOfPages"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedMetadata();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["totalItemCount"] = this.totalItemCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["numberOfPages"] = this.numberOfPages;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}
export class FEPagedItemsOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(FEItemOutputModel.fromJS(item));
            }
            this.metadata = _data["metadata"] ? PagedMetadata.fromJS(_data["metadata"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FEPagedItemsOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined;
        return data;
    }
}
export var BannerItemDestinationType;
(function (BannerItemDestinationType) {
    BannerItemDestinationType["None"] = "None";
    BannerItemDestinationType["Item"] = "Item";
    BannerItemDestinationType["Category"] = "Category";
})(BannerItemDestinationType || (BannerItemDestinationType = {}));
export class FEBannerItemOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.imageUrl = _data["imageUrl"] ? LocalizedStringOutputModel.fromJS(_data["imageUrl"]) : undefined;
            this.sortOrder = _data["sortOrder"];
            this.destinationType = _data["destinationType"];
            this.destinationOutlineId = _data["destinationOutlineId"];
            this.destinationName = _data["destinationName"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FEBannerItemOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl ? this.imageUrl.toJSON() : undefined;
        data["sortOrder"] = this.sortOrder;
        data["destinationType"] = this.destinationType;
        data["destinationOutlineId"] = this.destinationOutlineId;
        data["destinationName"] = this.destinationName;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    }
}
export class FEBannerOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.bannerPosition = _data["bannerPosition"];
            this.title = _data["title"] ? LocalizedStringOutputModel.fromJS(_data["title"]) : undefined;
            this.description = _data["description"] ? LocalizedStringOutputModel.fromJS(_data["description"]) : undefined;
            this.isVisible = _data["isVisible"];
            if (Array.isArray(_data["bannarItems"])) {
                this.bannarItems = [];
                for (let item of _data["bannarItems"])
                    this.bannarItems.push(FEBannerItemOutputModel.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FEBannerOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["bannerPosition"] = this.bannerPosition;
        data["title"] = this.title ? this.title.toJSON() : undefined;
        data["description"] = this.description ? this.description.toJSON() : undefined;
        data["isVisible"] = this.isVisible;
        if (Array.isArray(this.bannarItems)) {
            data["bannarItems"] = [];
            for (let item of this.bannarItems)
                data["bannarItems"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    }
}
export var HelpRequestFormFieldType;
(function (HelpRequestFormFieldType) {
    HelpRequestFormFieldType["TextField"] = "TextField";
    HelpRequestFormFieldType["TextArea"] = "TextArea";
    HelpRequestFormFieldType["Radio"] = "Radio";
    HelpRequestFormFieldType["Dropdown"] = "Dropdown";
    HelpRequestFormFieldType["ImageUpload"] = "ImageUpload";
})(HelpRequestFormFieldType || (HelpRequestFormFieldType = {}));
export class FEHelpRequestFormFieldOptionOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.title = _data["title"];
            this.sortOrder = _data["sortOrder"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FEHelpRequestFormFieldOptionOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["sortOrder"] = this.sortOrder;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    }
}
export class FEHelpRequestFormFieldOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.title = _data["title"];
            this.hint = _data["hint"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.showBasedOnSelectedOption = _data["showBasedOnSelectedOption"];
            this.showForOptionId = _data["showForOptionId"];
            this.showForOptionFieldId = _data["showForOptionFieldId"];
            this.isRequired = _data["isRequired"];
            if (Array.isArray(_data["options"])) {
                this.options = [];
                for (let item of _data["options"])
                    this.options.push(FEHelpRequestFormFieldOptionOutputModel.fromJS(item));
            }
            this.sortOrder = _data["sortOrder"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FEHelpRequestFormFieldOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["hint"] = this.hint;
        data["description"] = this.description;
        data["type"] = this.type;
        data["showBasedOnSelectedOption"] = this.showBasedOnSelectedOption;
        data["showForOptionId"] = this.showForOptionId;
        data["showForOptionFieldId"] = this.showForOptionFieldId;
        data["isRequired"] = this.isRequired;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        data["sortOrder"] = this.sortOrder;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    }
}
export class FEHelpRequestFormOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [];
                for (let item of _data["fields"])
                    this.fields.push(FEHelpRequestFormFieldOutputModel.fromJS(item));
            }
            this.sortOrder = _data["sortOrder"];
            this.maximumNumberRequests = _data["maximumNumberRequests"];
            this.trackNumberOfRequests = _data["trackNumberOfRequests"];
            this.isClosed = _data["isClosed"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FEHelpRequestFormOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["sortOrder"] = this.sortOrder;
        data["maximumNumberRequests"] = this.maximumNumberRequests;
        data["trackNumberOfRequests"] = this.trackNumberOfRequests;
        data["isClosed"] = this.isClosed;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    }
}
export class DedicationDesignOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sortOrder = _data["sortOrder"];
            this.imageUrl = _data["imageUrl"];
            this.pdfUrl = _data["pdfUrl"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DedicationDesignOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sortOrder"] = this.sortOrder;
        data["imageUrl"] = this.imageUrl;
        data["pdfUrl"] = this.pdfUrl;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    }
}
export class HelpRequestFieldInputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.text = _data["text"];
            this.selectedOptionId = _data["selectedOptionId"];
            this.imageName = _data["imageName"];
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HelpRequestFieldInputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["selectedOptionId"] = this.selectedOptionId;
        data["imageName"] = this.imageName;
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    }
}
export class HelpRequestInputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.formId = _data["formId"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [];
                for (let item of _data["fields"])
                    this.fields.push(HelpRequestFieldInputModel.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HelpRequestInputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}
export class UploadedImageFileOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fileName = _data["fileName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadedImageFileOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        return data;
    }
}
export class FEOrderSummaryOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.total = _data["total"];
            this.paymentId = _data["paymentId"];
            this.transactionId = _data["transactionId"];
            this.number = _data["number"];
            this.postDate = _data["postDate"];
            this.completedDate = _data["completedDate"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FEOrderSummaryOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["paymentId"] = this.paymentId;
        data["transactionId"] = this.transactionId;
        data["number"] = this.number;
        data["postDate"] = this.postDate;
        data["completedDate"] = this.completedDate;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    }
}
export class ExternnalPaymentUrlOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.url = _data["url"];
            this.orderId = _data["orderId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ExternnalPaymentUrlOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["orderId"] = this.orderId;
        return data;
    }
}
export class DedicationInfoInputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.hasDedication = _data["hasDedication"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.dedicationDesignId = _data["dedicationDesignId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DedicationInfoInputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["hasDedication"] = this.hasDedication;
        data["from"] = this.from;
        data["to"] = this.to;
        data["dedicationDesignId"] = this.dedicationDesignId;
        return data;
    }
}
export class OrderPaymentMethod {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.englishName = _data["englishName"];
            this.arabicName = _data["arabicName"];
            this.paymentMethodId = _data["paymentMethodId"];
            this.info = _data["info"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPaymentMethod();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["englishName"] = this.englishName;
        data["arabicName"] = this.arabicName;
        data["paymentMethodId"] = this.paymentMethodId;
        data["info"] = this.info;
        return data;
    }
}
export class FEOrderLineItemOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.originalItemId = _data["originalItemId"];
            this.name = _data["name"] ? LocalizedStringOutputModel.fromJS(_data["name"]) : undefined;
            this.barcode = _data["barcode"];
            this.type = _data["type"];
            this.paymentType = _data["paymentType"];
            this.fixedDonationAmount = _data["fixedDonationAmount"];
            this.quantity = _data["quantity"];
            this.paidAmount = _data["paidAmount"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FEOrderLineItemOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["originalItemId"] = this.originalItemId;
        data["name"] = this.name ? this.name.toJSON() : undefined;
        data["barcode"] = this.barcode;
        data["type"] = this.type;
        data["paymentType"] = this.paymentType;
        data["fixedDonationAmount"] = this.fixedDonationAmount;
        data["quantity"] = this.quantity;
        data["paidAmount"] = this.paidAmount;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    }
}
export class DedicationInfo {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.from = _data["from"];
            this.to = _data["to"];
            this.message = _data["message"];
            this.dedicationDesignId = _data["dedicationDesignId"];
            this.imageUrl = _data["imageUrl"];
            this.pdfUrl = _data["pdfUrl"];
            this.fromColor = _data["fromColor"];
            this.toColor = _data["toColor"];
            this.messageColor = _data["messageColor"];
            this.dedicationCardUrl = _data["dedicationCardUrl"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DedicationInfo();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["to"] = this.to;
        data["message"] = this.message;
        data["dedicationDesignId"] = this.dedicationDesignId;
        data["imageUrl"] = this.imageUrl;
        data["pdfUrl"] = this.pdfUrl;
        data["fromColor"] = this.fromColor;
        data["toColor"] = this.toColor;
        data["messageColor"] = this.messageColor;
        data["dedicationCardUrl"] = this.dedicationCardUrl;
        return data;
    }
}
export class FEOrderOutputModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.total = _data["total"];
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : undefined;
            this.paymentMethod = _data["paymentMethod"] ? OrderPaymentMethod.fromJS(_data["paymentMethod"]) : undefined;
            this.completedAt = _data["completedAt"];
            this.paymentId = _data["paymentId"];
            this.transactionId = _data["transactionId"];
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [];
                for (let item of _data["lineItems"])
                    this.lineItems.push(FEOrderLineItemOutputModel.fromJS(item));
            }
            this.trackID = _data["trackID"];
            this.number = _data["number"];
            this.refrenceID = _data["refrenceID"];
            this.paymentInfo = _data["paymentInfo"];
            this.dedicationInfo = _data["dedicationInfo"] ? DedicationInfo.fromJS(_data["dedicationInfo"]) : undefined;
            this.hasDedication = _data["hasDedication"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FEOrderOutputModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : undefined;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : undefined;
        data["completedAt"] = this.completedAt;
        data["paymentId"] = this.paymentId;
        data["transactionId"] = this.transactionId;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item.toJSON());
        }
        data["trackID"] = this.trackID;
        data["number"] = this.number;
        data["refrenceID"] = this.refrenceID;
        data["paymentInfo"] = this.paymentInfo;
        data["dedicationInfo"] = this.dedicationInfo ? this.dedicationInfo.toJSON() : undefined;
        data["hasDedication"] = this.hasDedication;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    }
}
export class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
